export const DEFAULT_EXIST_APP: any = [
  {
    id: 7,
    name: 'AI会议',
    url: 'https://browser.iwhop.cn/ai-conference',
    description: '便捷高效的线上会议平台，支持多人实时沟通协作',
    imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIhy3x.png'
  },
  {
    id: 9,
    name: 'AI绘图',
    url: 'https://browser.iwhop.cn/ai-drawing',
    description: '凭借人工智能，创作精美绝伦的各类画作',
    imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIhh3x.png'
  },
  {
    id: 10,
    name: 'AI表格',
    url: 'https://browser.iwhop.cn/ai-table',
    description: '智能化处理表格数据，高效完成数据分析与整理',
    imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIbg3x.png'
  },
  {
    id: 12,
    name: 'AI PPT',
    url: 'https://browser.iwhop.cn/ai-ppt',
    description: '助力打造炫酷 PPT，轻松提升演示效果',
    imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIPPT3x.png'
  },
  {
    id: 6,
    name: 'AI 对话',
    url: 'http://82.156.139.50:8084',
    description: 'AI智能助手，知识问答及文档处理',
    imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIdh3x.png'
  },
]

export const CHT_DEFAULT_EXIST_APP: any = [{
  label: '熱門產品',
  cards: [
      {
          "imgUrl": "https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIdh3x.png",
          "detailPageUrl": null,
          "name": "AI對話",
          "chargeType": null,
          "description": "AI智能助手，知識問答及文檔處理",
          "id": 6,
          "url": "/ai-gpt"
      },
      {
          "imgUrl": "https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIxz3x.png",
          "detailPageUrl": null,
          "name": "AI寫作",
          "chargeType": null,
          "description": "多種寫作場景的智能助手",
          "id": 8,
          "url": "/ai-write"
      },
      {
          id: 9,
          name: 'AI繪圖',
          url: '/ai-image-market',
          description: '憑藉人工智能，創作精美絕倫的各類畫作',
          imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIhh3x.png'
      },
      {
          id: 10,
          name: 'AI表格',
          url: '/ai-xlsx',
          description: '智能化處理表格數據，高效完成數據分析與整理',
          imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIbg3x.png'
      },
      {
          id: 12,
          name: 'AI PPT',
          url: "/ai-ppt-theme",
          description: '助力打造炫酷 PPT，輕鬆提升演示效果',
          imgUrl: 'https://dev-oss.iwhopro.com/cdn/wakeup/howear/wearfit-app/browserfunction/AIPPT3x.png'
      },
  ]
}];
export default DEFAULT_EXIST_APP;